import { createContext, useContext, ReactNode } from 'react';
import { ReviewDetailsTab } from './index';

interface ReviewDetailsContextProps {
  activeTab: ReviewDetailsTab;
  setActiveTab: (tab: ReviewDetailsTab) => void;
}

const ReviewDetailsContext = createContext<
  ReviewDetailsContextProps | undefined
>(undefined);

export const ReviewDetailsProvider = ({
  children,
  activeTab,
  setActiveTab
}: {
  children: ReactNode;
  activeTab: ReviewDetailsTab;
  setActiveTab: (tab: ReviewDetailsTab) => void;
}) => {
  return (
    <ReviewDetailsContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </ReviewDetailsContext.Provider>
  );
};

export const useReviewDetails = () => {
  const context = useContext(ReviewDetailsContext);
  if (!context) {
    throw new Error(
      'useReviewDetails must be used within an ReviewDetailsProvider'
    );
  }
  return context;
};
